module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/submissions_border-7a6a1f5232f375852d7284c809ca6cf5.svg";